import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import FileOpenIcon from '@mui/icons-material/FileOpen';
import { MenuItem, Select } from '@mui/material';
import { Stack } from '@mui/material';

import * as React from 'react';

import {NoCashIcon, DoNotServeIcon, ApprovalStatusNotSet} from '../Icons';
import { showToast } from '../utils/toast'


const StyledTableCell = styled(TableCell)({
    padding: 0
})

const formatTenants = (tenants) => {

    return(
        <TableContainer component={Paper} sx={{overflowY:'scroll', overflowX:'hidden', fontSize:8, height:"100%", paddingRight:1}}>
            <Table  size="small">
                <TableBody>
                    {tenants.split(', ').map((name) => (
                        <TableRow key={name}>
                            <StyledTableCell component="th" scope="row" >
                                <Typography fontSize={12}>{name}</Typography>
                            </StyledTableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    )
}

export const APPROVAL_OPTIONS = [
    { value: 'not_set', label: 'Not Set' },
    { value: 'remove', label: 'Remove' },
    { value: 'approved', label: 'Approved' },
    { value: 'certified', label: 'Certified' },
    { value: 'admin_approved', label: 'Admin Approved'}
];
    

export const FIVE_DAY_COLUMNS = (
    openModal, 
    setSelectedRow, 
    updateApprovalStatus, 
    userInfo, 
    editingId, 
    setEditingId, 
    setToastMessage,
    setToastSeverity,
    setToastOpen
) =>{ 
    
    return [
        { field: 'Accountnumber', headerName: 'Account #', width: 85 },
        { field: 'iconStatus', headerName: 'Status', minWidth: (37*3),
            renderCell: (props) => {
                let icons = [];
                if (!props.row.standardFeeAmount || 
                    !props.row.certifiedFeeAmount){
                    icons.push(<NoCashIcon id={'NCI' + props.row.Accountnumber}/>)
                }
                if (!props.row.status_text || props.row.status_text==='not_set'){
                    icons.push(<ApprovalStatusNotSet sx={{color: 'red'}} id={'NS' + props.row.Accountnumber}/>)
                }
                if (props.row.DoNotServe == 1){
                    icons.push(<DoNotServeIcon id={'DNS' + props.row.Accountnumber}/>)
                }

                return (
                    <Stack 
                        height="100%"
                        direction={"row"}
                        alignItems="center"
                    >
                        {icons}
                    </Stack>
                    )

                // return (<Checkbox disabled checked={props.row.DoNotServe == 1} />)
            }
        },
        { 
            field: 'Tenants', 
            headerName: 'Tenants',  
            minWidth: 150,
            renderCell: (props) => {
                return formatTenants(props.row.Tenants)
            }
        },
        { 
            field: 'Unit', 
            headerName: 'Unit', 
            minWidth: 200
        },
        { field: 'LeaseStartDate', headerName: 'Lease Start', flex: 1, type: 'date',
            valueGetter: (props) => {
                const date = new Date(props)
                return isNaN(date) ? "N/A" : date;
            }
        },
        { field: '0-30days', headerName: '0 - 30 days', flex: 1, type: 'number'},
        { field: '30-60days', headerName: '30 - 60 days', flex: 1, type: 'number'},
        { field: '60-90days', headerName: '60 - 90 days', flex: 1, type: 'number'},
        { field: '90+days', headerName: '90+ days', flex: 1, type: 'number'},
        { field: 'Balance', headerName: 'Balance', flex: 1, type: 'number'},
        { field: 'ServedLastMonth', headerName: 'Served Last Month', flex: 1},
        { field: 'City', headerName: 'City', flex: 1},
        { 
            field: 'status_text', 
            headerName: 'Approval Status', 
            flex: 1,
            minWidth: 120,
            renderCell: (params) => {
                return (
                <Select
                    value={params.value || 'not_set'}
                    onChange={async (event) => {
                        setEditingId(params.id);
                        const newValue = event.target.value;
                        try {
                            const response = await updateApprovalStatus(params.row, newValue);
                            if (response.ok) {
                                params.api.updateRows([{
                                    id: params.id,
                                    status_text: newValue
                                }]);
                            } else {
                                console.error('Failed to update status');
                                showToast(setToastMessage, setToastSeverity, setToastOpen, 'Assignment failed. Please try to assign in Dashboard', 'error');
                            }
                        } catch (error) {
                            console.error('Error updating status:', error);
                            showToast(setToastMessage, setToastSeverity, setToastOpen, `Error updating status: ${error.message}`, 'error');
                        }
                        finally {
                            setEditingId(null);
                        }
                    }}
                    disabled={editingId !=null && editingId !== params.id}
                    fullWidth
                >
                    {APPROVAL_OPTIONS.map(option => (
                        (userInfo.can_approve === 1) && (
                            <MenuItem 
                                key={option.value} 
                                value={option.value}
                            >
                                {option.label}
                            </MenuItem>
                        )
                    ))}
                </Select>
                )
        }
        },
        {field: 'LastComment', headerName: 'Last Comment', minWidth: 200,
            renderCell: (params) => {
                const comment = params.row.comments?.[0];
                return (
                    <div>
                        {comment ? (
                               <div 
                               style={{
                                cursor: 'pointer',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap'
                                }}
                             >
                               {comment.comment_text} - {comment.email}
                             </div>
                        ) : (
                            'No comments'
                        )}

                    </div>
                );
            },
    
        },
        {   headerName: 'Show Details',
            renderCell: (props) => {
                return (
                    <Button 
                        color={"#000"} 
                        onClick={(event)=>{
                            openModal('comments',{lease_id:props.row.Accountnumber})
                            event.stopPropagation(); // Stop event from bubbling up to row
                            setSelectedRow(props.row)
                        }}>
                        <FileOpenIcon />
                    </Button>)
        }
        },
    ];
}

    // {   field: 'Comments', 
    //     headerName: 'Comments',
    //     renderCell: (props) => {
    //         return (<Button 
    //                     color={"#000"} 
    //                     onClick={()=>openModal('comments',{lease_id:props.row.Accountnumber})}>
    //                     <FileOpenIcon />
    //                 </Button>)
    //     }
    // },